
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91slug_93dHPYkd2iGkMeta } from "/vercel/path0/pages/day-trip/[slug].vue?macro=true";
import { default as indexe9Brt5DfdhMeta } from "/vercel/path0/pages/index.vue?macro=true";
import { default as overviewb7G5HP3urUMeta } from "/vercel/path0/pages/overview.vue?macro=true";
import { default as partnersites7KvigGgpw0Meta } from "/vercel/path0/pages/partnersites.vue?macro=true";
import { default as _91slug_93Yuin2RXMLtMeta } from "/vercel/path0/pages/review/[slug].vue?macro=true";
import { default as budgetPlanner51gWaMM5QhMeta } from "/vercel/path0/pages/tools/budgetPlanner.vue?macro=true";
import { default as checklist1RuNGRz0iyMeta } from "/vercel/path0/pages/tools/checklist.vue?macro=true";
import { default as _91slug_936TQ1BIjhPKMeta } from "/vercel/path0/pages/vacation/[slug].vue?macro=true";
import { default as component_45stub5X4Ei38PMgMeta } from "/vercel/path0/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stub5X4Ei38PMg } from "/vercel/path0/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "day-trip-slug___en",
    path: "/day-trip/:slug()",
    component: () => import("/vercel/path0/pages/day-trip/[slug].vue")
  },
  {
    name: "day-trip-slug___nl",
    path: "/nl/day-trip/:slug()",
    component: () => import("/vercel/path0/pages/day-trip/[slug].vue")
  },
  {
    name: "index___en",
    path: "/",
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "index___nl",
    path: "/nl",
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "overview___en",
    path: "/overview",
    component: () => import("/vercel/path0/pages/overview.vue")
  },
  {
    name: "overview___nl",
    path: "/nl/overview",
    component: () => import("/vercel/path0/pages/overview.vue")
  },
  {
    name: "partnersites___en",
    path: "/partnersites",
    component: () => import("/vercel/path0/pages/partnersites.vue")
  },
  {
    name: "partnersites___nl",
    path: "/nl/partnersites",
    component: () => import("/vercel/path0/pages/partnersites.vue")
  },
  {
    name: "review-slug___en",
    path: "/review/:slug()",
    component: () => import("/vercel/path0/pages/review/[slug].vue")
  },
  {
    name: "review-slug___nl",
    path: "/nl/review/:slug()",
    component: () => import("/vercel/path0/pages/review/[slug].vue")
  },
  {
    name: "tools-budgetPlanner___en",
    path: "/tools/budgetPlanner",
    component: () => import("/vercel/path0/pages/tools/budgetPlanner.vue")
  },
  {
    name: "tools-budgetPlanner___nl",
    path: "/nl/tools/budgetPlanner",
    component: () => import("/vercel/path0/pages/tools/budgetPlanner.vue")
  },
  {
    name: "tools-checklist___en",
    path: "/tools/checklist",
    component: () => import("/vercel/path0/pages/tools/checklist.vue")
  },
  {
    name: "tools-checklist___nl",
    path: "/nl/tools/checklist",
    component: () => import("/vercel/path0/pages/tools/checklist.vue")
  },
  {
    name: "vacation-slug___en",
    path: "/vacation/:slug()",
    component: () => import("/vercel/path0/pages/vacation/[slug].vue")
  },
  {
    name: "vacation-slug___nl",
    path: "/nl/vacation/:slug()",
    component: () => import("/vercel/path0/pages/vacation/[slug].vue")
  },
  {
    name: component_45stub5X4Ei38PMgMeta?.name,
    path: "/sitemap.xml",
    component: component_45stub5X4Ei38PMg
  }
]